import React from 'react';
import ReactDOM from 'react-dom';
import { MuiPickersUtilsProvider, InlineDatePicker } from 'material-ui-pickers';
import { Button, withStyles, TextField, InputAdornment } from '@material-ui/core';
import MomentUtils from '@date-io/moment';
import { faCalendarAlt } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from 'moment';
import i18next from 'i18next';
import DateFormatService from '../../WorkplanManager/services/DateFormatService';
import { UkgDateFormat } from '../../WorkplanManager/Enums';

const CssTextField = withStyles({
	root: {
		height: 38,
		width: '100%',
		fontSize: '14px',
		'& .Mui-disabled': {
			backgroundColor: '#f3f3f3'
		},
		'& .MuiOutlinedInput-root': {
			width: '100%',
			height: 38
		},
		'& .MuiOutlinedInput-input': {
			width: '100%',
			height: 38,
			padding: 0
		}
	},
})(TextField);

const styles = theme => ({
	buttonLeft: {
		marginRight: '8px',
		backgroundColor: '#1a518a',
		color: 'white'
	},
	calendarButtons: {
		display: 'flex',
		float: 'right',
		marginRight: 8
	}
});

const MRWorkPlanRolloutItem = (props) => {
	const { label, minDate, maxDate, placeholder, weekStartDay, disableDates, error, disabled, clearable = false } = props;
	let invalidLabel = props.customButtonLabel !== 'undefined' ? props.customButtonLabel : '';

	let value = props.value === null || props.value === '3000-01-01' ? props.customButtonLabel : DateFormatService.formatDateOrEmpty(props.value, UkgDateFormat.LongDate)

	if (typeof weekStartDay !== 'undefined') {
		moment.updateLocale(i18next.language, {
			week: {
				dow: weekStartDay,
			},
		});
	}

	let customClickBand = false;

	const selectDateHandler = (date, props) => {
	if (!customClickBand)
		props.onChange(props.id, date.format('YYYY-MM-DD'))
	}

	const onOpenHandler = (props) => {
		customClickBand = false
		if (props.showCustomButton) {
			setTimeout(function () {
				let calendarButtons = document.createElement('div');
				calendarButtons.className = 'CUSTOM__calendarButtons';
				document.getElementById('picker-popover').childNodes[2].appendChild(calendarButtons)
				ReactDOM.render(createButton(props), calendarButtons);
			}, 1);
		}
	}

	const customClick = (props) => {
		customClickBand = true
		document.getElementById('picker-popover').childNodes[0].click();
	}

	const createButton = props => {		
		return (
			<div className={props.classes.calendarButtons}>
				<span style={{ marginRight: 10, color: '#1a518a', paddingTop: 9 }}>Maximum end date:</span>
				<Button variant="contained" onClick={() => customClick(props)} className={props.classes.buttonLeft}>
					{DateFormatService.formatDateOrEmpty(props.customButtonLabel, UkgDateFormat.LongDate)}
				</Button >
			</div>
		)
	}

	const closeHandler = (props) => {
		if (customClickBand) {
			let value = props.customButtonValue ? props.customButtonValue : null;
			props.onChange(props.id, value)
		}
	}

	return (
		<MuiPickersUtilsProvider utils={MomentUtils}>
			<InlineDatePicker
				error={error}
				minDate={minDate}
				maxDate={maxDate}
				disablePast
				invalidDateMessage=''
				TextFieldComponent={
					({ inputProps, onClick, inputRef }) =>
						<CssTextField 
							variant="outlined"
							disabled={disabled}
							placeholder={placeholder}
							value={value}
							onClick={onClick}
							inputRef={inputRef}
							InputProps={{
								inputProps,
								startAdornment: (
									<InputAdornment position="start" disabled={disabled}>
										<FontAwesomeIcon style={{ color: '#6ea0d7' }} icon={faCalendarAlt} />
									</InputAdornment>
								),
							}} />
				}
				onOpen={() => onOpenHandler(props)}
				onlyCalendar
				label={label}
				invalidLabel={invalidLabel}
				format={'YYYY-MM-DD'}
				value={props.value ? moment(props.value, 'YYYY-MM-DD') : null}
				onChange={date => selectDateHandler(date, props)}
				onClose={() => closeHandler(props)}
				shouldDisableDate={(date) => disableDates(date, props)}
				disabled={disabled}
				clearable={clearable}
			// openTo="year"
			// views={views}
			/>
		</MuiPickersUtilsProvider>
	);
}

export default withStyles(styles)(MRWorkPlanRolloutItem);